var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileLightBlankMultiple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.319 27H23.68C25.898 27 27 25.923 27 23.788v-9.317c0-1.324-.16-1.898-1.017-2.74l-5.897-5.756C19.274 5.175 18.599 5 17.4 5h-5.082C10.113 5 9 6.088 9 8.222v15.566C9 25.933 10.103 27 12.318 27zm.075-1.652c-1.103 0-1.671-.564-1.671-1.59V8.252c0-1.016.568-1.601 1.681-1.601h4.76v5.962c0 1.293.675 1.929 2.014 1.929h6.1v9.215c0 1.026-.57 1.59-1.682 1.59zm6.976-12.355c-.428 0-.59-.164-.59-.574V6.97l6.165 6.023z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.283 24V8c-.96.148-1.47.589-1.47 1.574v12.852c0 .985.51 1.426 1.47 1.574z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.344 21.656V10.344C3.447 10.402 3 10.887 3 11.779v8.442c0 .892.447 1.377 1.344 1.435z",
    opacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLightBlankMultiple);
export default __webpack_public_path__ + "static/media/File-Light_Blank-Multiple.2607f1efb777def7472517ba3150c0b5.svg";
export { ForwardRef as ReactComponent };